import React from 'react';
import { PropTypes } from 'prop-types';
// styles
import styled from 'styled-components';
import { useSoFormStepsState } from '../../SoForm.context';
import SoFormContainer from '../../components/layout/SoFormContainer';
import { GirdedInfoIcon } from 'refactored/ui/icons';
import { useSelector } from 'react-redux';
import { selectors as shipmentsSelectors } from 'state/shipments';
import { useTranslation } from 'react-i18next';

const TempContainer = styled.div`
  width: 100%;
  display: flex;
  text-align: center;
  gap: 10px;
  align-items: center;
  justify-content: center;
`;

const SoFormStepConfigurationInfo = ({ className }) => {
  const { t } = useTranslation('Catalog');

  const stepsState = useSoFormStepsState();
  const redux_address_from = useSelector((state) =>
    shipmentsSelectors.getShipmentAddress(state, 'FIRST_SHIPMENT', 'pickup')
  );
  const redux_address_to = useSelector((state) =>
    shipmentsSelectors.getShipmentAddress(state, 'FIRST_SHIPMENT', 'dropoff')
  );
  const showRegularErrors =
    stepsState.configuration.showConfigurationErrors &&
    stepsState.configuration.errors.fieldsWithEmptyError.length > 0;

  const showNoProductsForRoute =
    stepsState.configuration.showNoProductsForRoute;

  const showErrors = showRegularErrors || showNoProductsForRoute;
  const showZipCodeQuoteMsg =
    redux_address_from?.isZipcode || redux_address_to?.isZipcode;

  if (showErrors) return <></>;

  if (!showZipCodeQuoteMsg) return <></>;

  return (
    <div className={className}>
      <SoFormContainer>
        <TempContainer>
          <GirdedInfoIcon />
          {t('configuration.zipcode_warning')}
        </TempContainer>
      </SoFormContainer>
    </div>
  );
};

SoFormStepConfigurationInfo.propTypes = {
  className: PropTypes.string,
};

export default styled(SoFormStepConfigurationInfo)`
  border-bottom: 4px solid var(--primary300);
  background: white;
  width: 100%;
  margin-top: auto;
  text-align: center;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  padding: 12px 16px;
  padding-top: 0;
  color: #263340;
  /* Inside auto layout */

  text-align: center;

  svg {
    fill: var(--primary300);
    path {
      fill: var(--primary300);
    }
  }
`;
